export const ForwardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.59643 8.69627C8.13452 8.3841 8.13452 7.61585 7.59643 7.30367L1.23279 3.6118C0.712564 3.30999 0 3.65485 0 4.3081V11.6918C0 12.3451 0.712564 12.69 1.23279 12.3881L7.59643 8.69627Z"
      fill="#667180"
    />
    <path
      d="M15.5964 8.69627C16.1345 8.3841 16.1345 7.61585 15.5964 7.30367L9.23279 3.6118C8.71256 3.30999 8 3.65485 8 4.3081V11.6918C8 12.3451 8.71256 12.69 9.23279 12.3881L15.5964 8.69627Z"
      fill="#667180"
    />
  </svg>
);
